import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatSnackBarModule,
  MatTooltipModule
} from '@angular/material';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcOutlinedInputModule } from '@core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { FcTextAreaInputModule } from '@core/components/fc-input/base/fc-text-area-input/fc-text-area-input.module';
import { FcEquipmentTypeInputModule } from '@core/components/fc-input/search-one/fc-equipment-type-input/fc-equipment-type-input.module';
import { FcLocationEnvironmentInputModule } from '@core/components/fc-input/search-one/fc-location-environment-input/fc-location-environment-input.module';
import { FcLocationInputModule } from '@core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { FcLocationSectorInputModule } from '@core/components/fc-input/search-one/fc-location-sector-input/fc-location-sector-input.module';
import { VideoInfoModalModule } from '@core/components/video-info-modal/video-info-modal.module';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ViewQrCodeModalModule } from '../../../../../core/components/view-qr-code-modal/view-qr-code-modal.module';
import { DirectivesModule } from '../../../../../core/directives/directives.module';
import { TabNewGeneralComponent } from './tab-new-general.component';

@NgModule({
  declarations: [
    TabNewGeneralComponent,
  ],
  exports: [
    TabNewGeneralComponent
  ],
  imports: [
    FormsModule,
    TranslateModule,
    FuseSharedModule,
    ReactiveFormsModule,

    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,

    FcTextAreaInputModule,
    FcDateInputModule,
    FcOutlinedInputModule,
    FcLocationInputModule,
    VideoInfoModalModule,
    FcEquipmentTypeInputModule,
    FcLocationSectorInputModule,
    FcLocationEnvironmentInputModule,
    ViewQrCodeModalModule,
    DirectivesModule
  ],
  providers: [
    CustomMessagesService
  ]
})
export class TabNewGeneralModule { }
